import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-heart-remove",
  "use": "icon-si-glyph-heart-remove-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-heart-remove\" id=\"icon-si-glyph-heart-remove\"><title>156</title><defs></defs><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(0.000000, 1.000000)\" fill=\"#434343\"><path d=\"M9.917,9.917 L13.613,9.917 C14.931,8.398 15.968,6.453 15.968,4.062 C15.968,1.833 14.173,0.031 11.957,0.031 C10.044,0.031 8.446,1.379 8.046,3.179 C7.63,1.376 6.025,0.031 4.101,0.031 C1.864,0.031 0.051,1.855 0.051,4.103 C0.051,10.599 8.056,13.941 8.056,13.941 C8.056,13.941 8.841,13.617 9.916,12.967 L9.916,9.917 L9.917,9.917 Z\" class=\"si-glyph-fill\" /><rect x=\"11\" y=\"11\" width=\"4.958\" height=\"0.918\" class=\"si-glyph-fill\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-heart-remove.svg
// module id = lEpL
// module chunks = 62